import { A } from '@solidjs/router'
import ThemeToggle from './ThemeToggle'

export default function TopBar() {
  return (
    <>
      <header class="topbar">
        <div class="topbar__brand">
          <A href="/" aria-label="ccxp home">
            <b class="brand-mark">ccxp</b>
          </A>
          <span class="topbar__sep" />
          <span>CCTP message inspector</span>
        </div>
        <ThemeToggle />
      </header>
      <div class="topbar__prism prism-mark" />
    </>
  )
}
